import React from 'react';

// reusable component to check whether string contains number or not
const containsNumber = (str: string): boolean => {
  return /\d/.test(str);
};

export default containsNumber;
